import type { ReactNode } from 'react';

import {
  SelectReceiver,
  UltimateDebtorFillOrgInfoSwitch,
  UltimateDebtorSameAsReceiver
} from '../FormExtensions';
import type { DraftSteps, StepFormExtensionProps } from '../utils/types';

type StepFormExtension = {
  StartOfFormSection?: (p: StepFormExtensionProps) => ReactNode | null;
  EndOfFormSection?: (p: StepFormExtensionProps) => ReactNode | null;
};

const REGISTRY: Partial<Record<DraftSteps, StepFormExtension>> = {
  ultimate_debtor: {
    StartOfFormSection: UltimateDebtorFillOrgInfoSwitch,
    EndOfFormSection: UltimateDebtorSameAsReceiver
  },
  creditor: {
    StartOfFormSection: SelectReceiver
  }
};

export const useStepFormExtensions = (step: DraftSteps) => {
  return REGISTRY[step] ?? {};
};
